import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Features251 from '../components/features251'
import Features241 from '../components/features241'
import Pricing6 from '../components/pricing6'
import Logos1 from '../components/logos1'
import Footer4 from '../components/footer4'
import './services.css'

const Services = (props) => {
  return (
    <div className="services-container">
      <Helmet>
        <title>Services - Sydrisworx</title>
        <meta property="og:title" content="Services - Sydrisworx" />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="services-text10">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="services-text11">Services</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="services-text12">Contact Us</span>
          </Fragment>
        }
      ></Navbar8>
      <h2 className="services-text13 thq-heading-2">About Us</h2>
      <Features251
        imageSrc2="https://images.unsplash.com/photo-1531482615713-2afd69097998?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fGJsYWNrJTIwb2ZmaWNlJTIwd29ya2VyfGVufDB8fHx8MTc0MjI4NzkyN3ww&amp;ixlib=rb-4.0.3&amp;w=1500"
        feature1Title={
          <Fragment>
            <span className="services-text14">Empowerment Through Skills</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="services-text15">Empower Minds</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="services-text16">Strategic Networking</span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="services-text17">
              Equip individuals and organizations with the right data-driven
              strategies, insights, and skills to unlock their full potential
              and drive business success.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="services-text18">
              Empower businesses and professionals with the knowledge, skills,
              and tools they need to leverage data, strategy, and innovation,
              ensuring no one is left behind in the digital transformation
              journey.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="services-text19">
              Build a strong network of strategic partners, industry leaders,
              and innovators who are committed to driving business growth
              through data solutions, strategic alignment, and continuous
              learning.
            </span>
          </Fragment>
        }
      ></Features251>
      <Features241
        imageSrc2="https://images.unsplash.com/photo-1517840933437-c41356892b35?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDY2fHxkaXZlcnNpdHl8ZW58MHx8fHwxNzQyMjg4MTAwfDA&amp;ixlib=rb-4.0.3&amp;w=1500"
        feature1Title={
          <Fragment>
            <span className="services-text20">Diversity and Inclusion</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="services-text21">Excellence in Delivery</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="services-text22">Integrity and Trust</span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="services-text23">
              Foster an inclusive environment where businesses and individuals,
              regardless of background, can thrive through data-driven
              solutions, strategic insights, and skills development.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="services-text24">
              Deliver high-quality data solutions, advisory services, and
              training programs that drive measurable business impact.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="services-text25">
              Build long-term partnerships based on trust, transparency, and
              ethical business practices, ensuring sustainable growth and value
              creation.
            </span>
          </Fragment>
        }
      ></Features241>
      <Pricing6
        plan1={
          <Fragment>
            <span className="services-text26">Basic Plan</span>
          </Fragment>
        }
        plan2={
          <Fragment>
            <span className="services-text27">Premium Plan</span>
          </Fragment>
        }
        plan3={
          <Fragment>
            <span className="services-text28">Ultimate Plan</span>
          </Fragment>
        }
        plan11={
          <Fragment>
            <span className="services-text29">
              Data Solutions and Digital Transformation
            </span>
          </Fragment>
        }
        plan21={
          <Fragment>
            <span className="services-text30">
              Strategy &amp; Advisory Services
            </span>
          </Fragment>
        }
        plan31={
          <Fragment>
            <span className="services-text31">
              Skills Development &amp; Training
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="services-text32">Our Services</span>
          </Fragment>
        }
        plan1Price={
          <Fragment>
            <span className="services-text33">$50</span>
          </Fragment>
        }
        plan2Price={
          <Fragment>
            <span className="services-text34">$80</span>
          </Fragment>
        }
        plan3Price={
          <Fragment>
            <span className="services-text35">$120</span>
          </Fragment>
        }
        plan1Action={
          <Fragment>
            <span className="services-text36">Sign Up Now</span>
          </Fragment>
        }
        plan1Yearly={
          <Fragment>
            <span className="services-text37">$500/year</span>
          </Fragment>
        }
        plan2Action={
          <Fragment>
            <span className="services-text38">Sign Up Now</span>
          </Fragment>
        }
        plan2Yearly={
          <Fragment>
            <span className="services-text39">$800/year</span>
          </Fragment>
        }
        plan3Action={
          <Fragment>
            <span className="services-text40">Sign Up Now</span>
          </Fragment>
        }
        plan3Yearly={
          <Fragment>
            <span className="services-text41">$1200/year</span>
          </Fragment>
        }
        plan1Feature1={
          <Fragment>
            <span className="services-text42">Standard Home Cleaning</span>
          </Fragment>
        }
        plan1Feature2={
          <Fragment>
            <span className="services-text43">Flexible Scheduling</span>
          </Fragment>
        }
        plan1Feature3={
          <Fragment>
            <span className="services-text44">Customized Solutions</span>
          </Fragment>
        }
        plan2Feature1={
          <Fragment>
            <span className="services-text45">Deep Cleaning Services</span>
          </Fragment>
        }
        plan2Feature2={
          <Fragment>
            <span className="services-text46">Priority Scheduling</span>
          </Fragment>
        }
        plan2Feature3={
          <Fragment>
            <span className="services-text47">Personalized Cleaning Plans</span>
          </Fragment>
        }
        plan2Feature4={
          <Fragment>
            <span className="services-text48">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature1={
          <Fragment>
            <span className="services-text49">Luxury Home Cleaning</span>
          </Fragment>
        }
        plan3Feature2={
          <Fragment>
            <span className="services-text50">Weekly Cleaning Sessions</span>
          </Fragment>
        }
        plan3Feature3={
          <Fragment>
            <span className="services-text51">Exclusive Add-On Services</span>
          </Fragment>
        }
        plan3Feature4={
          <Fragment>
            <span className="services-text52">Premium feature</span>
          </Fragment>
        }
        rootClassName="pricing6root-class-name"
        plan1Feature11={
          <Fragment>
            <span className="services-text53">
              Unlock the potential of your business through innovative data
              solutions and comprehensive digital transformation strategies. Our
              focus is on fostering insights that drive value creation, enabling
              you to achieve your business objectives in a rapidly evolving
              digital landscape.
            </span>
          </Fragment>
        }
        plan1Feature21={
          <Fragment>
            <span className="services-text54">Business Intelligence</span>
          </Fragment>
        }
        plan1Feature31={
          <Fragment>
            <span className="services-text55">Technology Integration</span>
          </Fragment>
        }
        plan2Feature11={
          <Fragment>
            <span className="services-text56">
              Our strategy and advisory services empower businesses to navigate
              immediate challenges, foster mid-term innovation, and cultivate
              long-term sustainable growth. We offer a structured and
              forward-thinking approach tailored to your needs.
            </span>
          </Fragment>
        }
        plan2Feature21={
          <Fragment>
            <span className="services-text57">
              Data &amp; Infrastructure Gap Assessment
            </span>
          </Fragment>
        }
        plan2Feature31={
          <Fragment>
            <span className="services-text58">Transformation Go-to Plan</span>
          </Fragment>
        }
        plan3Feature11={
          <Fragment>
            <span className="services-text59">
              Enhance your team&apos;s capabilities with our diverse skills
              development and training programs. Our expert facilitators
              customise learning experiences to meet specific client needs,
              ensuring impactful training outcomes.
            </span>
          </Fragment>
        }
        plan3Feature21={
          <Fragment>
            <span className="services-text60">14+ Tailored Programs</span>
          </Fragment>
        }
        plan3Feature31={
          <Fragment>
            <span className="services-text61">Expert Facilitation</span>
          </Fragment>
        }
        plan3Feature41={
          <Fragment>
            <span className="services-text62">
              Client-Centric Curriculum Development
            </span>
          </Fragment>
        }
        plan1Feature111={
          <Fragment>
            <span className="services-text63">Professional Services</span>
          </Fragment>
        }
        plan1Feature311={
          <Fragment>
            <span className="services-text64">Data Analytics Services</span>
          </Fragment>
        }
        plan2Feature211={
          <Fragment>
            <span className="services-text65">
              <span>AI Readiness Assessment</span>
              <br></br>
            </span>
          </Fragment>
        }
        plan2Feature311={
          <Fragment>
            <span className="services-text68">Strategic Planning Support</span>
          </Fragment>
        }
        plan2Feature312={
          <Fragment>
            <span className="services-text69">Implementation Roadmaps</span>
          </Fragment>
        }
        plan3Feature411={
          <Fragment>
            <span className="services-text70">Workshops and Seminars</span>
          </Fragment>
        }
        plan3Feature412={
          <Fragment>
            <span className="services-text71">
              Continuous Learning Opportunities
            </span>
          </Fragment>
        }
        plan1Feature1111={
          <Fragment>
            <span className="services-text72">Management Consulting</span>
          </Fragment>
        }
      ></Pricing6>
      <Logos1
        heading1={
          <Fragment>
            <span className="services-text73">
              Trusted by the world&apos;s best companies to build credibility
            </span>
          </Fragment>
        }
        rootClassName="logos1root-class-name"
      ></Logos1>
      <Footer4
        link1={
          <Fragment>
            <span className="services-text74">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="services-text75">Services</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="services-text76">Contact Us</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default Services
